var global = require('../internals/global');
var isObject = require('../internals/is-object');

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/document-create-element.js
// module id = 374
// module chunks = 1